export default {
  rubrik: {
    kasek: {
      1: [
        {
          key: 'K1',
          title: 'KOMPETENSI 1',
          label: `Mengembangkan lingkungan kelas yang memfasilitasi murid belajar secara aman dan nyaman`,
          skorings: [
            {
              key: '71',
              skors: [0, 1, 2, 3, 4],
            },
            {
              key: '72',
              skors: [0, 1, 2, 3, 4],
            },
          ],
        },
        {
          key: 'K2',
          title: 'KOMPETENSI 2',
          label: `Memandu dan merefleksikan proses belajar mengajar yang efektif`,
          skorings: [
            {
              key: '73',
              skors: [0, 1, 2, 3, 4],
            },
            {
              key: '74',
              skors: [0, 1, 2, 3, 4],
            },
          ],
        },
        {
          key: 'K3',
          title: 'KOMPETENSI 3',
          label: `Menunjukkan kebiasaan refleksi untuk pengembangan diri (self regulated learning)`,
          skorings: [
            {
              key: '75',
              skors: [0, 1, 2, 3, 4],
            },
          ],
        },
        {
          key: 'K4',
          title: 'KOMPETENSI 4',
          label: `Mendesain proses belajar mengajar yang efektif`,
          skorings: [
            {
              key: '76',
              skors: [0, 1, 2, 3, 4],
            },
          ],
        },
      ],
    },
    instruktur: {
      1: [
        {
          key: 'K1',
          title: 'KOMPETENSI 1',
          label: `Mengembangkan lingkungan kelas yang memfasilitasi peserta untuk berpartisipasi secara aktif dalam pelatihan  secara aman dan nyaman`,
          skorings: [
            {
              key: '271',
              skors: [0, 1, 2, 3, 4],
            },
            {
              key: '272',
              skors: [0, 1, 2, 3, 4],
            },
          ],
        },
        {
          key: 'K2',
          title: 'KOMPETENSI 2',
          label: `Memandu dan merefleksikan proses belajar mengajar yang efektif selama pelatihan`,
          skorings: [
            {
              key: '273',
              skors: [0, 1, 2, 3, 4],
            },
            {
              key: '274',
              skors: [0, 1, 2, 3, 4],
            },
          ],
        },
        {
          key: 'K3',
          title: 'KOMPETENSI 3',
          label: `Menunjukkan kebiasaan refleksi untuk pengembangan diri (self regulated learning) dalam rangka perbaikan fasilitasi pelatihan secara berkelanjutan`,
          skorings: [
            {
              key: '275',
              skors: [0, 1, 2, 3, 4],
            },
          ],
        },
        {
          key: 'K4',
          title: 'KOMPETENSI 4',
          label: `Mendesain proses pelatihan yang efektif`,
          skorings: [
            {
              key: '276',
              skors: [0, 1, 2, 3, 4],
            },
          ],
        },
      ],
    },
  },
  panduan: {
    kasek: {
      1: {
        71: {
          NA: [''],
          1: ['Tidak secara eksplisit menjelaskan tujuan pembelajaran dan aktivitas yang akan dilakukan.'],
          2: ['Secara eksplisit menjelaskan tujuan pembelajaran dan/atau aktivitas yang akan dilakukan.'],
          3: [
            'Secara eksplisit menjelaskan tujuan pembelajaran dan/atau aktivitas yang akan dilakukan dan mengaitkan tujuan pembelajaran dengan materi/informasi yang sudah didapat murid di pelajaran sebelumnya atau dengan kehidupan nyata/kehidupan sekitar.',
          ],
          4: [
            'Secara eksplisit menjelaskan tujuan pembelajaran dan/atau aktivitas yang akan dilakukan dan mengaitkan tujuan pembelajaran dengan materi/informasi yang sudah didapat murid di pelajaran sebelumnya serta dengan keadaan nyata/kehidupan sekitar.',
          ],
          5: [
            'Secara eksplisit menjelaskan tujuan pembelajaran dan/atau aktivitas yang akan dilakukan dan mengaitkan materi/informasi yang sudah didapat murid di pelajaran sebelumnya serta dengan keadaan nyata/kehidupan sekitar dengan mengajukan pertanyaan-pertanyaan terbuka yang dapat memantik murid dalam berpikir.',
          ],
        },
        72: {
          NA: [''],
          1: [
            'Mempraktikkan komunikasi satu arah tanpa instruksi-instruksi yang dapat melibatkan murid dalam praktik pembelajaran.',
          ],
          2: [
            'Mempraktikkan komunikasi dua arah dalam memberikan instruksi, walaupun beberapa instruksi belum menggunakan bahasa yang sesuai dengan karakteristik murid dan jenjang yang diajar.',
          ],
          3: [
            'Mempraktikkan komunikasi dua arah dalam memberikan instruksi dan menggunakan bahasa yang sesuai dengan karakteristik murid dan jenjang yang diajar.',
          ],
          4: [
            'Mempraktikkan komunikasi dua arah dalam memberikan instruksi dan menggunakan Bahasa yang sesuai dengan karakteristik murid dan jenjang yang diajar. Memberikan apresiasi positif dalam pembelajaran.',
          ],
          5: [
            'Mempraktikkan komunikasi dua arah dalam memberikan instruksi dan menggunakan Bahasa yang sesuai dengan karakteristik murid dan jenjang yang diajar. Memberikan apresiasi positif dan menggunakan pertanyaan terbuka untuk memantik keterlibatan anak dalam diskusi.',
          ],
        },
        73: {
          NA: [''],
          1: ['Dalam proses pembelajaran bahasa tubuh terlihat kaku dan tidak bebas bergerak.'],
          2: [
            'Dalam proses pembelajaran menunjukkan 3 (tiga) diantara bahasa tubuh positif: senyuman, anggukan, menggunakan gerakan tangan, bersemangat dalam penyampaian, kontak visual yang baik, dan badan yang condong kepada murid.',
          ],
          3: [
            'Dalam proses pembelajaran menunjukkan 4 (empat) diantara bahasa tubuh positif: senyuman, anggukan, menggunakan gerakan tangan, bersemangat dalam penyampaian, kontak visual yang baik, dan badan yang condong kepada murid.',
          ],
          4: [
            'Dalam proses pembelajaran menunjukkan 5 (lima) diantara bahasa tubuh positif: senyuman, anggukan, menggunakan gerakan tangan, bersemangat dalam penyampaian, kontak visual yang baik, dan badan yang condong kepada murid.',
          ],
          5: [
            'Dalam proses pembelajaran menunjukkan seluruh bahasa tubuh positif: senyuman, anggukan, menggunakan gerakan tangan, bersemangat dalam penyampaian, kontak visual yang baik, dan badan yang condong kepada murid.',
          ],
        },
        74: {
          NA: [''],
          1: [
            'Aktivitas pembelajaran dilakukan tanpa menggunakan contoh atau alat peraga dalam menjelaskan inti pembelajaran.',
          ],
          2: [
            'Aktivitas pembelajaran dilakukan dengan menggunakan contoh atau alat peraga dalam menjelaskan inti pembelajaran. ',
          ],
          3: [
            'Aktivitas pembelajaran dilakukan dengan menggunakan contoh atau alat peraga dalam menjelaskan inti pembelajaran. Guru mengajak murid untuk melakukan diskusi terkait pembelajaran.',
          ],
          4: [
            'Aktivitas pembelajaran dilakukan dengan menggunakan contoh atau alat peraga dalam menjelaskan inti pembelajaran. Guru memandu murid berdiskusi  secara berpasangan (pair work) atau dalam kelompok (group work).',
          ],
          5: [
            'Aktivitas pembelajaran dilakukan dengan menggunakan contoh atau alat peraga dalam menjelaskan inti pembelajaran. Guru memberikan kesempatan murid memimpin proses berdiskusi  secara berpasangan(pair work) atau dalam kelompok (group work).',
          ],
        },
        75: {
          NA: [''],
          1: [
            'Dapat melakukan refleksi diri terhadap praktik pembelajaran dengan menyebutkan kelemahan dan/atau kelebihan yang terkait hanya pada faktor eksternal (alat peraga, kondisi murid, kondisi sekolah, dll.) bukan pada faktor  pribadi (internal) guru.',
          ],
          2: [
            'Dapat melakukan refleksi diri terhadap praktik pembelajaran dengan menjelaskan kelemahan dan/atau kelebihan pribadi (faktor internal).',
          ],
          3: [
            'Dapat melakukan refleksi terhadap praktik pembelajaran dengan menjelaskan kelemahan dan kelebihan pribadi serta pengembangan praktik di pembelajaran berikutnya.',
          ],
          4: [
            'Dapat melakukan refleksi terhadap praktik pembelajaran dengan menjelaskan kelemahan dan kelebihan pribadi serta pengembangan praktik di pembelajaran berikutnya dan dampaknya terhadap murid (student-centered learning).',
          ],
          5: [
            'Dapat melakukan refleksi terhadap praktik pembelajaran dengan menjelaskan kelemahan dan kelebihan pribadi serta pengembangan praktik di pembelajaran berikutnya dan dampaknya terhadap murid (student-centered learning) dan menyebutkan salah satu rencana konkrit untuk melakukan pengembangan diri.',
          ],
        },
        76: {
          NA: [''],
          1: [
            'Dapat menyebutkan (namun tidak menjelaskan lebih lanjut) jenis penilaian yang akan diberikan dan cara melakukannya. Contoh: "Saya memakai penilaian pilihan ganda dan memberikan tugasnya di akhir pelajaran"',
          ],
          2: [
            'Dapat menjelaskan satu jenis penilaian yang akan diberikan dan cara melakukannya yang sesuai dengan tujuan pembelajaran.',
          ],
          3: [
            'Dapat menjelaskan satu jenis penilaian yang akan diberikan dan cara melakukannya, sesuai dengan tujuan pembelajaran, dan menggunakan hasil penilaian untuk ditindak lanjuti untuk hasil belajar murid (cth: Pemberikan pelajaran tambahan, remedial, dll.), atau untuk meningkatkan kualitas belajar.',
          ],
          4: [
            'Dapat menjelaskan beragam jenis penilaian (menilai lebih dari satu aspek) yang akan diberikan dan cara melakukannya, sesuai dengan tujuan pembelajaran, dan menggunakan hasil penilaian untuk ditindak lanjuti untuk hasil belajar murid (cth: Pemberikan pelajaran tambahan, remedial, dll.), atau untuk meningkatkan kualitas belajar.',
          ],
          5: [
            'Dapat menjelaskan beragam jenis penilaian (menilai lebih dari satu aspek) yang akan diberikan dan cara melakukannya, sesuai dengan tujuan pembelajaran, dan menggunakan hasil penilaian untuk ditindak lanjuti untuk hasil belajar murid (cth: Pemberikan pelajaran tambahan, remedial, dll.), serta untuk meningkatkan kualitas belajar.',
          ],
        },
      },
    },
    instruktur: {
      1: {
        271: {
          NA: [''],
          1: ['Tidak menyebutkan tujuan pelatihan.'],
          2: ['Menyebutkan secara eksplisit tujuan pelatihan.'],
          3: [
            'Menjelaskan tujuan pelatihan dengan memberikan pertanyaan-pertanyaan yang membuat peserta memikirkan kebutuhan dan/atau motivasi mereka namun tidak menggunakan metode diskusi seperti brainstorming atau brainwriting.',
          ],
          4: [
            'Melibatkan peserta dalam memahami tujuan pelatihan dengan cara membangkitkan kesadaran peserta akan kebutuhan belajar atau menggali motivasi mereka untuk mempelajari materi pelatihan (contoh brainstorming atau brainwriting, dengan mengajukan pertanyaan spt "apa pertanyaan yg ingin dijawab stlh ikut pelatihan?" / "Apa yg membuat Bapak/Ibu ingin ikut pelatihan ini?" /"Ada yang mau memberikan pendapat atau share motivasi mengikuti pelatihan ini?").',
          ],
          5: [
            'Melibatkan peserta dalam memahami tujuan pelatihan dengan cara membangkitkan kesadaran peserta akan kebutuhan belajar dan menggali motivasi mereka untuk mempelajari materi pelatihan (contoh brainstorming atau brainwriting, dengan mengajukan pertanyaan spt "apa pertanyaan yg ingin dijawab stlh ikut pelatihan?" / "Apa yg membuat Bapak/Ibu ingin ikut pelatihan ini?" /"Ada yang mau memberikan pendapat atau share motivasi mengikuti pelatihan ini?").',
          ],
        },
        272: {
          NA: [''],
          1: [
            'Mempraktikkan komunikasi satu arah tanpa instruksi-instruksi yang dapat melibatkan peserta dalam aktivitas pelatihan. Contoh metode: Lecturing/Kuliah umum',
          ],
          2: [
            'Mempraktikkan komunikasi satu arah dan menunjukkan 1 (satu) dari 3 (tiga) perilaku positif berikut:  (1) bersemangat, (2) menggunakan gerakan tangan yg wajar dalam mendukung pelatihan, (3) pandangan mata/kontak visual diberikan kepada peserta pelatihan (tidak terpaku pada materi/papan tulis/tampilan proyektor). ',
          ],
          3: [
            'Mempraktikkan komunikasi dua arah melalui pertanyaan diskusi terhadap peserta, dan menunjukkan 2 (dua) dari 4 (empat) perilaku positif berikut:  (1) bersemangat, (2) melibatkan peserta dalam pembicaraan, (3) menggunakan gerakan tangan yg wajar dalam mendukung pelatihan, (4) pandangan mata/kontak visual diberikan kepada peserta pelatihan (tidak terpaku pada materi/papan tulis/tampilan proyektor).',
          ],
          4: [
            'Mempraktikkan komunikasi dua arah melalui pertanyaan diskusi terhadap peserta, dan menunjukkan 3 (tiga) dari 4 (empat) perilaku positif berikut:  (1) bersemangat, (2) melibatkan peserta dalam pembicaraan, (3) menggunakan gerakan tangan yg wajar dalam mendukung pelatihan, (4) pandangan mata/kontak visual diberikan kepada peserta pelatihan (tidak terpaku pada materi/papan tulis/tampilan proyektor).',
          ],
          5: [
            'Mempraktikkan komunikasi dua arah melalui pertanyaan diskusi terhadap peserta, dan menunjukkan semua perilaku positif berikut:  (1) bersemangat, (2) melibatkan peserta dalam pembicaraan, (3) menggunakan gerakan tangan yg wajar dalam mendukung pelatihan, (4) pandangan mata/kontak visual diberikan kepada peserta pelatihan (tidak terpaku pada materi/papan tulis/tampilan proyektor).',
          ],
        },
        273: {
          NA: [''],
          1: [
            'Aktivitas pelatihan tidak disertai dengan  indikator berikut: (1) media yang mendukung pelatihan (contoh: bahan paparan, dokumen tercetak, video, dll.), (2) memberi contoh/data yang berkaitan dengan tujuan pelatihan.',
          ],
          2: [
            'Aktivitas pelatihan disertai dengan 1 (satu) dari indikator berikut: (1) media yang mendukung pelatihan (contoh: bahan paparan, dokumen tercetak, video, dll.), (2) memberi contoh/data yang berkaitan dengan tujuan pelatihan. ',
          ],
          3: [
            'Aktivitas pelatihan disertai dengan 2 (dua) dari indikator berikut: (1) metode pelatihan yang melibatkan peserta spt diskusi (peserta dgn pelatih atau antar peserta), (2) media yang mendukung pelatihan (contoh: bahan paparan, dokumen tercetak, video, dll.), (3) memberi contoh/data yang berkaitan dengan tujuan pelatihan. ',
          ],
          4: [
            'Aktivitas pelatihan disertai dengan 3 (tiga) indikator berikut:  (1) metode pelatihan yang melibatkan peserta spt diskusi (peserta dgn pelatih atau antar peserta), (2) media yang mendukung pelatihan (contoh: bahan paparan, dokumen tercetak, video, dll.), (3) memberi contoh/data yang berkaitan dengan tujuan pelatihan. ',
          ],
          5: [
            'Aktivitas pelatihan disertai dengan 3 (tiga) indikator berikut:  (1) metode pelatihan yang melibatkan peserta spt diskusi (peserta dgn pelatih atau antar peserta), (2) media yang mendukung pelatihan (contoh: bahan paparan, dokumen tercetak, video, dll.), (3) mendorong peserta untuk memberi contoh/data yang berkaitan dengan tujuan pelatihan, contoh: mengajukan pertanyaan-pertanyaan pemantik agar peserta pelatihan mengutarakan contoh-contoh/data "Apakah Bapak/Ibu bisa memberikan contoh kesulitan yang dihadapi murid ketika belajar daring?; Apa saja dampak yang akan dirasakan murid-murid jika metode ini dilakukan di kelas?; Berapa banyak sekolah di daerah Bapak/Ibu yang kesulitan mengakses internet?"',
          ],
        },
        274: {
          NA: [''],
          1: [
            'Di akhir proses pelatihan, pelatih tidak melakukan kegiatan refleksi. Contoh: menarik kesimpulan setelah pelatihan.',
          ],
          2: [
            'Di akhir proses pelatihan, pelatih memberi refleksi berupa penjelasan langsung kepada peserta. Contoh: Pelatih menjelaskan kesimpulan secara langsung "Kesimpulan pelatihan kita hari ini adalah..."',
          ],
          3: [
            'Selama proses pelatihan menggunakan 1 (satu) dari 3 (tiga) di antara aktivitas refleksi berikut: (1) menanyakan kesimpulan dari pelatihan yang diberikan; (2) menanyakan bagaimana rencana lanjutan peserta setelah proses pelatihan ini; (3) menanyakan bagaimana perasaan peserta selama pelatihan.',
          ],
          4: [
            'Selama proses pelatihan menggunakan 2 (dua) dari 3 (tiga) di antara aktivitas refleksi berikut: (1) menanyakan kesimpulan dari pelatihan yang diberikan; (2) menanyakan bagaimana rencana lanjutan peserta setelah proses pelatihan ini; (3) menanyakan bagaimana perasaan peserta selama pelatihan..',
          ],
          5: [
            'Selama proses pelatihan menggunakan seluruh aktivitas refleksi berikut: (1) menanyakan kesimpulan dari pelatihan yang diberikan; (2) menanyakan bagaimana rencana lanjutan peserta setelah proses pelatihan ini; (3) menanyakan bagaimana perasaan peserta selama pelatihan.',
          ],
        },
        275: {
          NA: [''],
          1: [
            'Dapat melakukan refleksi diri terhadap praktik pelatihan dengan menyebutkan kelemahan dan/atau kelebihan yang terkait, namun hanya pada faktor eksternal (misalnya peserta pelatihan, fasilitas, keadaan, dll)/bukan pada faktor  pribadi (internal) pelatih.',
          ],
          2: [
            'Dapat melakukan refleksi diri terhadap praktik pelatihan dengan menjelaskan kelemahan dan kelebihan pada faktor pribadi/internal.',
          ],
          3: [
            'Dapat melakukan refleksi diri terhadap praktik pelatihan dengan menjelaskan kelemahan dan kelebihan pada faktor internal/pribadi, dan menyampaikan perbaikan pada pelatihan sesungguhnya.',
          ],
          4: [
            'Dapat melakukan refleksi diri terhadap praktik pelatihan dengan menjelaskan kelemahan dan kelebihan pada faktor internal/pribadi, dan menyampaikan perbaikan pada pelatihan sesungguhnya serta  dampaknya terhadap peserta pelatihan.',
          ],
          5: [
            'Dapat melakukan refleksi diri terhadap praktik pelatihan dengan menjelaskan kelemahan dan kelebihan pada faktor internal/pribadi, dan menyampaikan perbaikan pada pelatihan sesungguhnya serta dampaknya terhadap peserta pelatihan dan menyebutkan rencana pengembangan diri sebagai pelatih.',
          ],
        },
        276: {
          NA: [''],
          1: [
            'Dapat menyebutkan satu jenis strategi utk evaluasi hasil pelatihan serta cara melakukannya, tetapi tidak menjelaskan lebih lanjut cara melakukannya. Contoh: "Saya akan memberikan kuesioner di akhir pelatihan" - tidak menjelaskan mengapa di berikan kuesioner di akhir pelatihan.',
          ],
          2: [
            'Dapat menjelaskan satu jenis strategi utk evaluasi hasil pelatihan serta cara merealisasinya, dan telah sesuai dengan tujuan pelatihan.',
          ],
          3: [
            'Dapat menjelaskan satu jenis strategi utk evaluasi hasil pelatihan serta cara merealisasinya, dan telah sesuai dengan tujuan pelatihan, dan menggunakan hasil evaluasi tersebut untuk tindak lanjut pelatihan berikutnya.',
          ],
          4: [
            'Dapat menjelaskan dua jenis strategi utk evaluasi hasil pelatihan serta cara merealisasinya, dan telah sesuai dengan tujuan pelatihan, dan menggunakan hasil evaluasi tersebut untuk tindak lanjut pelatihan berikutnya.',
          ],
          5: [
            'Dapat menjelaskan lebih dari dua jenis strategi utk evaluasi hasil pelatihan serta cara merealisasinya, dan telah sesuai dengan tujuan pelatihan, dan menggunakan hasil evaluasi tersebut untuk tindak lanjut pelatihan berikutnya.',
          ],
        },
      },
    },
  },
};
